<script>
	// This component can be used just like a <style> element, except within another Vue component's template, allowing it to access reactive props and data!
	/* Example:
	<VStyle>
		body
		{
			background-color: {{bgColor}};
		}
	</VStyle>
	*/
	import { h } from 'vue';
	export default {
		render: function ()
		{
			return h('style', this.$slots.default ? this.$slots.default() : []);
		}
	}
</script>
